import { IServiceInterfaceLog } from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";
import { FilterType, IFilter } from "@/types/filter.types";

export const SERVICE_INTERFACE_LOG_TABLE_COLUMNS = (messages: ServiceInterfaceMessages) => [
  messages.idColumn,
  messages.logTypeColumn,
  messages.logMessageColumn,
  messages.rowDateColumn,
];

export const initialLogFilterValues: IFilter<IServiceInterfaceLog>[] = [];

export const LOG_MESSAGE_MAX_LENGTH = 50;
